'use strict';

/**
 * Базовый класс транспорта Веб-агента.
 *
 * @class BaseTransport
 * @abstract
 * @since 5.1.0.1500
 */
(function (global) {
  var BaseTransport = Class.extend({
    className: 'BaseTransport',
    name: 'base',
    _isCanceled: false,
    _abstractMethodWarning: 'Should not be used directly. Must be overriden.',
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function () {
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отправляет запрос Агенту веб-доступа.
     * Реализация отправки данных.
     *
     * @method BaseTransport#call
     * @abstract
     * @param {string} requestName Имя запроса
     * @param {string} pluginName Имя плагина Агента, к которому идет обращение. Для базовых вызовов к ядру Веб-агента передается пустая строка
     * @param {Object} params Параметры запроса
     * @returns {Object} Результат запроса.
     * @since 5.1.0.1500
     */
    call: function (requestName, pluginName, params) {
      global.agentCore.log.warn(this._abstractMethodWarning);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Перезапускает Веб-агент.
     *
     * @method BaseTransport#restart
     * @returns {AgentCore.transport.BaseTransport} Объект типа BaseTransport.
     * @since 5.1.0.1511
     */
    restart: function () {
      this._isCanceled = false;
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Запускает Веб-агент.
     *
     * @method BaseTransport#start
     * @returns {AgentCore.transport.BaseTransport} Объект типа BaseTransport.
     * @since 5.1.0.1500
     */
    start: function () {
      this._isCanceled = false;
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Ожидает запуск Веб-агента.
     *
     * @method BaseTransport#waitForStart
     * @param {string} sessionId ID сессии пользователя.
     * @param {number} timeout таймаут.
     * @param {function} callbackWhenNotRegistered Функция, вызываемая если регистрация сессии отклонена агентом.
     * @return {Deferred<Object>} Признак успешности выполнения.
     * @see https://api.jquery.com/category/deferred-object/
     * @since 5.1.0.1511
     */
    waitForStart: function (sessionId, timeout, callbackWhenNotRegistered) {
      var me = this;
      var result = $.Deferred();

      if (!sessionId) {
        sessionId = '';
      }

      timeout = timeout || 60000;

      var startTime = $.now();
      var getSessionRegistrationStatus = function () {
        // Если установка отменена - выполнить reject
        if (me._isCanceled) {
          result.reject('canceled');
          return result;
        }

        // Если promise разрешен, проверять статус сессии больше не нужно.
        var state = result.state();
        if (state === 'rejected' || state === 'resolved') {
          return;
        }

        if ($.now() - startTime > timeout) {
          result.reject('timeout');
          return result;
        }

        setTimeout(function () {
          var params = {
            method: 'GetSessionRegistrationStatus',
            SessionID: sessionId
          };
          me._send(params).done(function (doc, method, xhr) {
            var response = xhr.responseText;
            var respObj = $.parseJSON(response);

            if (respObj.success === true) {
              if (respObj.result === 'REGISTERED') {
                global.agentCore.log.info('AGENT: Session successfully registered by agent');
                result.resolve(true);
              } else if (respObj.result === 'PROXIED') {
                global.agentCore.log.info('AGENT: Agent operates by using the service.');
                global.agentCore.updateWorkingPorts(sessionId);
                result.resolve(true);
              } else if (respObj.result === 'NOTREGISTERED') {
                global.agentCore.log.info('AGENT: Session registration rejected by agent');
                result.resolve(false);
                if (typeof callbackWhenNotRegistered === 'function') callbackWhenNotRegistered();
              }
            } else {
              if (respObj.result === 'ERR_INVALID_REQUEST_NAME') { //Уж не знаю правда ли так, но если это убрать то в старом агенте тост будет висеть 1 мин.
                //Агент старой версии, данный метод не поддерживается
                result.reject('oldagent');
              } else {
                getSessionRegistrationStatus();
              }
            }

            return result;
          }).fail(function () {
            getSessionRegistrationStatus();
          });
        }, 200);

        return result;
      };

      setTimeout(function () {
        getSessionRegistrationStatus();
      }, 300); //Небольшая задержка для того что бы URL-схема передала агенту нужную информацию, если он уже был запущен (#93952).

      return result;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отправляет запрос Агенту веб-доступа.
     * Если при первом запуске веб-доступа Агент не запустился, то запрос не отправляется.
     *
     * @method BaseTransport#transmitRequest
     * @param {string} requestName Имя запроса
     * @param {string} pluginName Имя плагина Агента, к которому идет обращение. Для базовых вызовов к ядру Веб-агента передается пустая строка
     * @param {Object} params Параметры запроса
     * @param {Object} extraParams Дополнительные параметры запроса (например, timeout)
     * @returns {Deferred<Object>} Результат запроса.
     * @see https://api.jquery.com/category/deferred-object/
     * @since 5.1.0.1500
     */
    transmitRequest: function (requestName, pluginName, params, extraParams) {
      var d = $.Deferred();

      if (typeof params.SessionID === 'undefined') params['SessionID'] = '';

      //переводим параметры в строковые значения
      for (var k in params) {
        params[k] = '' + params[k];
      }

      this.call(requestName, pluginName, params, extraParams).done(function (response) {
        var respObj;

        if (!response) {
          d.reject({ message: 'Uknown error', success: false });
          return;
        }
        if (response === 'OK') {
          d.resolve({ message: 'OK', success: true });
          return;
        }

        if (response === 'true') {
          d.resolve({ result: 'true', success: true });
          return;
        }

        if (response === 'false') {
          d.resolve({ result: 'false', success: true });
          return;
        }

        if (response === 'PONG') {
          d.resolve({ message: 'PONG', success: true });
          return;
        }
        try {
          respObj = $.parseJSON(response);
          try {
            respObj.result = $.parseJSON(respObj.result.replace(/'/g, '"'));
          } catch (_) {
          }
          if (!respObj.success)
            d.reject(respObj);
          d.resolve(respObj);
        } catch (e) {
          global.agentCore.log.error(e.message);
          if ($.isPlainObject(respObj) && 'message' in respObj) {
            ShowError(respObj.message);
          } else {
            ShowError(response);
          }
          d.reject(null);
        }
      }).fail(function (response) {
        d.reject({ message: 'CONNECTION_NOT_AVAILABLE', success: false });
      });

      return d.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отменяет запуск Веб-агента.
     *
     * @method BaseTransport#cancelStart
     * @since 5.4.0.1006
     */
    cancelStart: function () {
      this._isCanceled = true;
    }
  });

  global.agentCore.transport.BaseTransport = BaseTransport;

})(window);